import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Box, Heading } from '@landtrustinc/design-system';

import { SectionAvailableActivities } from '../..';
import InquiryWizardPanel from '../InquiryWizardPanel';
import InquiryWizardSection from '../InquiryWizardSection';

import css from './InquiryWizardStepActivities.module.css';

const InquiryWizardStepActivities = ({ listing, form, onNext }) => {
  const handleSubmit = values => {
    form.change('activity', values);
    onNext();
  };

  return (
    <InquiryWizardPanel>
      <InquiryWizardSection rootClassName={css.flushSection}>
        <Box mb="var(--spacing-3)">
          <Heading as="h1" size="2xs" fontWeight="extrabold" color="var(--color-primary-800)">
            <FormattedMessage id="NewInquiryPage.chooseActivity" />
          </Heading>
        </Box>
        <div className={css.sectionContainer}>
          <SectionAvailableActivities
            rootClassName={css.sectionActivities}
            title=""
            listing={listing}
            onSubmit={values => {
              handleSubmit(values.activity);
            }}
          />
        </div>
      </InquiryWizardSection>
    </InquiryWizardPanel>
  );
};

export default InquiryWizardStepActivities;
